if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.monitorNostoInjection('.pxg-style-with-bunle', 'bundle');
        this.monitorNostoInjection('.pxg-you-may-also-like', 'upsell');
      }

      checkIfBothMissing() {
        if (this.hasCheckedBoth) return;
      
        const bundleExists = document.querySelector('.pxg-style-with-bunle .nosto-element') ||
                             document.querySelector('.pxg-style-with-bunle')?.children.length > 0;
      
        const upsellExists = document.querySelector('.pxg-you-may-also-like .nosto-element') ||
                             document.querySelector('.pxg-you-may-also-like')?.children.length > 0;
      
        if (!bundleExists && !upsellExists) {
           this.hasCheckedBoth = true;
           const tabDescriptionBtn = document.querySelector("#tab-description");
          
            if (tabDescriptionBtn) {
              tabDescriptionBtn.click();
            }
        }
      }
      
     monitorNostoInjection(selector, keyName) {
        document.querySelectorAll(selector).forEach((targetElement) => {
          const superParent = targetElement.closest('.border-pine');
          if (!superParent) return;
      
          const observer = new MutationObserver(() => {
            const hasInjectedContent =
              targetElement.querySelector('.nosto-element') || targetElement.children.length > 0;
      
            if (hasInjectedContent) {
              observer.disconnect();
            } else {
              setTimeout(() => {
                const stillEmpty = targetElement.children.length === 0;
                if (stillEmpty) {
                  superParent.classList.add('nosto-missing');
                  this.missingSections[keyName] = true;
                  this.checkIfBothMissing(); // Check both only if this one was missing
                }else{
                  superParent.classList.add('nosto-loaded');
                }
                observer.disconnect();
              }, 2000);
            }
          });
      
          observer.observe(targetElement, {
            childList: true,
            subtree: true,
          });
      
          setTimeout(() => {
            const stillEmpty = targetElement.children.length === 0;
            if (stillEmpty) {
              superParent.classList.add('nosto-missing');
              this.missingSections[keyName] = true;
              this.checkIfBothMissing(); // Fallback if mutation didn’t happen
            }else{
              superParent.classList.add('nosto-loaded');
            }
            observer.disconnect();
          }, 5000);
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if (formData.get('bundle')) {
          // Remove the id and quantity for the default variant, added by the bundle JSON
          formData.delete('id');
          formData.delete('quantity');
          // Turn the bundle JSON into FormData
          config.body = this.bundleJsonToFormData(formData, formData.get('bundle'));
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      // Convert bundle JSON to Shopify format FormData
      // Examples: items[0]id, items[0]quantity, items[0]properties[name]
      bundleJsonToFormData(formData, jsonString) {
        const { items } = JSON.parse(jsonString);

        Object.keys(items).forEach((key, index) => {
          if (typeof items[key] === 'object' && !Array.isArray(items[key])) {
            // Handle multiple nested objects
            Object.keys(items[key]).forEach((nestedKey) => {
              if (typeof items[key][nestedKey] === 'object' && !Array.isArray(items[key][nestedKey])) {
                Object.keys(items[key][nestedKey]).forEach((nestedNestedKey) => {
                  formData.append(
                    `items[${index}]${nestedKey}[${nestedNestedKey}]`,
                    items[key][nestedKey][nestedNestedKey],
                  );
                });
              } else {
                formData.append(`items[${index}]${nestedKey}`, items[key][nestedKey]);
              }
            });
          }
        });
        return formData;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
